exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item{font-weight:700;display:flex;flex-direction:row;padding:0}.selected{background-color:#aaa;color:#fff}input{font-weight:400}.selected button,input{color:#000}.field-item{display:flex;flex-direction:row;list-style:none;text-align:left;max-width:100%}.field-data{width:178px;border:1px solid #000;border-top:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9eb2367c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DataListItem.vue
// module id = 27
// module chunks = 0